







































































import { defineComponent, watch, PropType } from '@vue/composition-api';

import { toastError } from '@/helpers/toast';

import AtomDivider from '@/components/atoms/AtomDivider.vue';

export default defineComponent({
  name: 'DropdownMenuBase',
  components: {
    AtomDivider,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    fit: {
      type: Boolean,
      required: true,
    },
    status: {
      type: String as PropType<
        'loading' | 'error' | 'linked' | 'notLinked' | 'added' | 'notAdded'
      >,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const onClickButton = (onClickButtonEvent: Event) => {
      if (props.status === 'error') {
        toastError(
          'プロジェクトの読み込みに失敗しました。ページを再読み込みしてください。',
        );
        return;
      }
      if (props.value) {
        return;
      }

      const closeMenu = () => {
        document.body.removeEventListener('click', bodyClickHandler);
        unwatch();
        emit('input', false);
      };

      const bodyClickHandler = (bodyClickHandlerEvent: Event) => {
        // button クリック時、メニューが即時に閉じられるのを防ぐ
        if (onClickButtonEvent !== bodyClickHandlerEvent) {
          closeMenu();
        }
      };

      const unwatch = watch(
        () => props.value,
        newValue => {
          if (!newValue) {
            closeMenu();
          }
        },
      );

      document.body.addEventListener('click', bodyClickHandler);
      emit('input', true);
    };

    return {
      onClickButton,
    };
  },
});
